import { PublicKey } from '@solana/web3.js';
import { RaffleMetaData } from '../lib/types';
import { TESTING } from './misc';

const testWhitelist = new Map<string, RaffleMetaData>([
 [
    'D6JLiSFeXGvruVgNWr2zQzdoyrGvvoda946qcR19on8y',
    {
      name: 'gangsta goonz #1157',
      overviewImageUri: '/resources/gg1.png',
    },
  ],
  [
    '6MPPQiFKbJajBzw5GLMcB57HZFHTLiZ5u2gordBAZatt',
    {
      name: 'SkelliesDAO',
      overviewImageUri: '/resources/thumb.png',
    },
  ],
]);

const prodWhitelist = new Map<string, RaffleMetaData>([
 [
    'Bzue9bdjTgBAgdgKAVoDS39zVoTXNY3R9AxkvhnpewEN',
    {
      name: 'gangsta goonz #1157',
      overviewImageUri: '/resources/gg1.png',
    },
  ],
  [
    '5q9kfryUxmEh1kY3hje4eY3fNdHrk7iPuzwbvMnYX8rL',
    {
      name: 'Thumbwars Raffle',
      overviewImageUri: '/resources/thumb.png',
    },
  ],
    [
    '4DvADHkStSV42QoDMxbC5GfKeY3ffkBtDfjAhLpBUgZP',
    {
      name: 'Minute Men Raffle!',
      overviewImageUri: '/resources/mm1.png',
    },
  ],
    [
    'ZFUPN9vNrNTfT1LXiyvKeKm4denoEXnUYosa9wDRmRx',
    {
      name: 'Yeah Tigers #2847',
      overviewImageUri: '/resources/tiger1.png',
    },
  ],
    [
    '43J3Yx2Ey5o4r7LMCe12W7ZRxSHBWpHzWT2q97rcJdTm',
    {
      name: '3 Rare Thumb Warriors!',
      overviewImageUri: '/resources/thumb3.png',
    },
  ],
     [
    'CCer6uRp1iupcajqeWXMNAd6XJxjUa5q9xvnpwc1mux7',
    {
      name: 'Cat Cartel #2745',
      overviewImageUri: '/resources/cc1.png',
    },
  ],
    [
    '8xzEVF8o4KyoK1LbYpgqcE2gsMj6iADgzmrET8J6GczK',
    {
      name: 'Thumbwars Mega Raffle #2',
      overviewImageUri: '/resources/mega2.gif',
    },
  ],
    [
    'F2e5vuyrXfcZEq5xtxcC5CouXnoPvWkqcHtXm6KJ3t6w',
    {
      name: 'Thumbwars Mega Raffle',
      overviewImageUri: '/resources/mega.gif',
    },
  ],
]);


export const RAFFLES_WHITELIST = TESTING ? testWhitelist : prodWhitelist;
